import React from "react";
import { Box, Input, Link } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Loading from "./Loading";
import { useParams } from "react-router";
import { decrypt, encrypt } from "utils/encryption";
import { useGetUrlMutation } from "store/resume.slice";
import StreamAttachmentComponent from "./Stream";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const Resume = () => {
  const [reqGet, resGet] = useGetUrlMutation();
  const { resumeData } = useSelector((state: any) => state.resume);

  const param = useParams();
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get("type");
  const resumeIdParam = searchParams.get("resumeId");
  const type = typeParam ? decrypt(typeParam) : null;
  const resumeId = resumeIdParam ? decrypt(resumeIdParam) : null;

  const buildPayload = () => {
    const id = decrypt(param.id);
    if (type === "interview_id") {
      return { resume_id: resumeId, interview_id: id };
    } else if (type === "submit_id") {
      return { resume_id: resumeId, submit_id: id };
    } else {
      return { candidate_id: id };
    }
  };

  useEffect(() => {
    reqGet(buildPayload());
  }, [param.id]);

  return (
    <Box
      style={{
        textAlign: "center",
        backgroundColor: "#E7EDF4",
      }}
    >
      {resGet.isLoading ? (
        <Loading />
      ) : (
        <StreamAttachmentComponent
          filename={
            resumeData?.resume
              ? resumeData.resume.file_name
              : resumeData?.file_name
          }
          fileUrl={resumeData?.resume ? resumeData.resume.url : resumeData?.url}
          data={resumeData?.email}
          type={type}
          resumeId={resumeId}
          pdfHeight={"98vh"}
          docHeight={"98vh"}
        />
      )}
    </Box>
  );
};

export default Resume;
